<template>
  <div id="Contact">
   
	<div id='contactPage'>
		<div class='bannerBox' :style="{backgroundImage:'url('+require('@/assets/about/aboutUs.jpg')+')'}"></div>
		<div class='contactBox'>
			<div class='contactName'>承诺 </div>
			<div class='contactTitle' style="text-indent: 2em;">我们致力于保护您在使用我们网站时所提供的私隐、私人资料以及个人的资料( 统称 "个人资料" ), 使我们在收集、使用、储存和传送个人资料方面符合 (与个人资料私隐有关的法律法规) 及消费者保护方面的最高标准。</div>
			<div class='contactTitle'>为确保您对我们在处理个人资料上有充分信心, 您切要详细阅读及理解隐私政策的条文。特别是您一旦使用我们的网站, 将被视为接受、同意、承诺和确认: </div>
			<div class='contactTitle'>您在自愿下连同所需的同意向我们披露个人资料; <br/>您会遵守本隐私政策的全部条款和限制; <br/>您在我们的网站上作登记、资料会被收集; <br/>您同意日后我们对隐私政策的任何修改; <br/>您同意我们的分公司、附属公司、雇员、就您可能会感兴趣的产品和服务与您联络( 除非您已经表示不想收到该等讯息 )。</div>

			<div class='contactName'>被收集的个人资料的种类 </div>
			<div class='contactTitle'  style="text-indent: 2em;">经您同意, 我们会收集、管理和监控个人资料。为了向您提供我们的各项服务, 您需要供給那些我们认为为达到你的指示和进一步改善我们的服务所需的个人资料和不具名的资料, 包括但不限于: </div>
			<div class='contactTitle'  style="text-indent: 2em;">个人资料-您的姓名、性别、年龄、出生日期、、电话号码、传真号码、住址或通讯地址、电子邮箱地址。</div>
			<div class='contactName'>不具名的资料</div>
			<div class='contactTitle'>收集个人资料及不具名的资料的目的及用途如下: <br/>通过我们的网站向您提供我们的各项服务; <br/>当您使用我们的网站时, 能辨认及确认您的身份; <br/>让您使用我们的网站时得到为您而设的感受; <br/>我们的顾客服务人员有需要时可以与您联系; <br/>统计我们网站使用量的数据; <br/>令您使用我们网站时更方便; <br/>为改进我们的产品、服务及网站内容而进行市场研究调查; <br/>为我们搞的活动、市场销售和推广计划收集资料; <br/>遵守法律、政府和监管机关的规定, 包括但不限于对个人资料披露及通知的规定; <br/>让我们及可能处于您住的国家之外的我们的分公司、附属公司、关联公司、雇员、代理人、服务伙伴或其它跟我们合作的第三者进行产品及/或服务的推广; <br/>就我们提供的各项服务, 分析、核对及/或审查您的信用、付款及/或地位; <br/>处理在您要求下的任何付款指示, 直接扣帐及/或信用安排; <br/>使您能运作您的账户及/或使我们能从账户支取尚欠的服务费; </div>

			<div class='contactName'>直销</div>
			<div class='contactTitle'  style="text-indent: 2em;">一旦向我们提供了您的个人资料, 您可能会收到我们或我们的分公司而发给你的电话、电邮和直销通讯。若您不希望收到我们的直销和推广资料, 请按照下列地址写信给我们。我们会尊重您的要求, 不再在直销活动上使用您的个人资料。</div>

			<div class='contactName'>个人资料的保护</div>
			<div class='contactTitle'  style="text-indent: 2em;">我们实施妥适的实物、电子、管理及技术方面的措施来保护和保障您的个人资料的安全。我们尽力确保通过我们网站所搜集的任何个人资料皆免于任何与我们无关的第三者的滋扰。我们采取的安全措施包括但不限于:
				<br/>实物措施: 存有您个人资料的记录会被存放在有锁的地方。 
				<br/>电子措施: 存有您个人资料的电脑数据会被存放在受严格登入限制的电脑系统和存储媒体上。 
				<br/>管理措施: 只有经我们授权的职员才能接触到您的个人资料, 这些职员需要遵守我们个人资料保密的内部守则。 
				<br/>技术措施: 可能采用如Secure Socket Layer Encryption这种加密技术来输送您的个人资料。 
				<br/>其它措施: 我们的网络服务器受到"防火墙"的保护。</div>
			<div class='contactTitle'  style="text-indent: 2em;">若您知悉我们的网站上有任何安全方面的漏洞, 请不要遟疑去联絡我们, 使我们可以尽快采取妥适的行动。</div>
			<div class='contactTitle'  style="text-indent: 2em;">尽管实施了上述技术和保安的措施, 我们不能保证资料在互联网上的输送绝对安全, 因此我们不能绝对保证您通过我们网站提供给我们的个人资料在一切时候都是安全的。对任何因未经授权而接触您个人资料所发生的事件我们一槪不承担责任, 于这方面产生或导致的任何损失或损害, 我们也不负责赔偿。 </div>

			<div class='contactName'>隐私政策的修改 </div>
			<div class='contactTitle'  style="text-indent: 2em;">本隐私政策可以不时( 无需事先向您通知 )被修改。任何对隐私政策的修改都会刊登在我们网站上。</div>
			<div class='contactName'>联系我们  </div>
			<div class='contactTitle'  style="text-indent: 2em;">若您对我们的隐私政策有任何问题或憂慮, 欢迎随时联系我们。info@xiaojudai.cn</div>
		</div>

	</div>
    <Foot />
  </div>

</template>

<script>
// @ is an alias to /src
import Foot from '@/components/foot.vue'
export default {
  name: 'privacy',
  components: {
   
      Foot
  },
  data:()=>{
  	return{
  		name:"",
  		mail:"",
  		talk:""
  	}
  	
  },

  methods:{
	inContact(){
		console.log(this.name,this.mail,this.talk)
		this.name=""
		this.mail=""
		this.talk=""
	}
  },
  mounted:function(){
 	this.$store.commit("saveOrderStep",0)
  	 $('html,body').animate({scrollTop:0},10);
  },
}
</script>
<style>
#Contact{
	width: 100%;
	height:100%;
}
#contactPage{

}
.bannerBox{
	width: 100%;
	height:44vw;
	background-repeat: no-repeat;
	  background-size: 100%;
	  background-position:center;
	  -moz-background-size: 100% 100%;
}
.contactBox{
	max-width: 1024px;
	width: 71vw;
	min-height:540px;
	margin:4vw auto 120px;
	overflow: hidden;

}
.contactName{
	text-align:center;
	padding-top:50px; 
	font-size:0.32rem;
	font-family:"PingFangSC-Medium";
	font-weight:600;
	color:rgba(20,20,20,1);
	line-height:42px;
	letter-spacing:1px;
	margin:29px 0 17px;
}
.contactTitle{
	text-align:left;
	text-align: justify;
	font-size:0.28rem;
	font-family:"PingFangSC-Medium";
	font-weight:500;
	color:rgba(20,20,20,1);
	line-height:33px;
	letter-spacing:1px;
	margin-bottom: 50px;
}
.contactBox input{
	display: block;
	width:520px;
	background:rgba(249,249,250,1);
	margin:0 auto 10px;
	outline: none;
	border: 0;
	padding: 15px 13px;
	font-size: 16px;

}
.nameIn{
	height:48px;
}

.mailIn{
	height:48px;
}
.talkIn{
    height:140px;
    display: block;
	width:520px;
	background:rgba(249,249,250,1);
	margin:0 auto 20px;
	outline: none;
	border: 0;
	padding: 15px 13px;
	font-size: 16px;
	resize: none;
}

.contactBox input::-webkit-input-placeholder{
        color: #BBB;
}
.contactBox input::-moz-placeholder{ 
        color: #BBB;        
}
.contactBox input::-ms-input-placeholder{ 
        color: #BBB;       
}
.contactBox textarea::-webkit-input-placeholder{
        color: #BBB;
}
.contactBox textarea::-moz-placeholder{ 
        color: #BBB;        
}
.contactBox textarea::-ms-input-placeholder{ 
        color: #BBB;       
}

.contactBtn{
	width:520px;
	height:48px;
	line-height: 48px;
	background:rgba(194,94,77,1);
	font-size:16px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	letter-spacing:1px;
	margin:0 auto;
}
</style>